import React from 'react'
import designAUrl from 'url:./canvases/design-a.svg'
import designBUrl from 'url:./canvases/design-b.svg'
import designCUrl from 'url:./canvases/design-c.svg'

export const CANVASES = [
  {
    id: 'design-a',
    label: 'Design A',
    svgUrl: designAUrl,
    pageId: 'd0709c88-8a13-48f6-9f74-cfed90fa3915',
    hexId: '09b538ea443ebed3',
    pregeneratedKey: 'design-a'
  },
  {
    id: 'design-b',
    label: 'Design B',
    svgUrl: designBUrl,
    pageId: 'a4106b11-1ee9-4d3d-99aa-fb6fc08d1655',
    hexId: '379a79a3fd3a824b',
    pregeneratedKey: 'design-b'
  },
  {
    id: 'design-c',
    label: 'Design C',
    svgUrl: designCUrl,
    pageId: '9ac46e54-ac49-40d8-9603-ca9b7348459b',
    hexId: 'a4dce07b4b46151a',
    pregeneratedKey: 'design-c'
  }
]

export function CanvasPicker ({ selectedId, onSelect }) {
  return (
    <div className='canvas-picker'>
      <p className='canvas-picker-title'>Designs</p>
      {CANVASES.map((canvas) => (
        <div
          key={canvas.id}
          className={`canvas-card${selectedId === canvas.id ? ' selected' : ''}`}
          onClick={() => onSelect(canvas)}
          role='button'
          tabIndex={0}
          onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') onSelect(canvas) }}
        >
          <img
            className='canvas-card-thumb'
            src={canvas.svgUrl}
            alt={canvas.label}
            draggable={false}
          />
          <span className='canvas-card-label'>{canvas.label}</span>
        </div>
      ))}
    </div>
  )
}
